enum UtilizationModule {
  network = 'Network',
  coordinate = 'Coordinate',
  visits = 'Visits',
  medicationLogistics = 'MedicationLogistics',
  clientAllocation = 'ClientAllocation',
  ai = 'Ai',
  resources = 'Resources',
  clients = 'Clients',
  userProfile = 'UserProfile',
  reports = 'Reports',
  // TODO: AI - Verify if this is correct
  aiAssist = 'AiAssist',
}

export default UtilizationModule;
